import { apiService } from './apiService';

function toQuery(params) {
  const usp = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') usp.append(k, v);
  });
  const s = usp.toString();
  return s ? `?${s}` : '';
}

export const publicJobsService = {
  async listJobs({ postcode, serviceId, page = 1, perPage = 20 } = {}) {
    const qs = toQuery({ postcode, service_id: serviceId, page, per_page: perPage });
    return apiService.get(`/api/v1/public/jobs${qs}`, { includeAuth: false });
  },

  async searchProviders({ serviceCategory, location, postcode, ratingMin, sortBy, page = 1, perPage = 20 } = {}) {
    const qs = toQuery({
      service_category: serviceCategory,
      location,
      postcode,
      rating_min: ratingMin,
      sort_by: sortBy,
      page,
      per_page: perPage,
    });
    return apiService.get(`/api/v1/providers/search${qs}`, { includeAuth: false });
  },
};

export default publicJobsService;
